/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
// import Dashboard from "layouts/dashboard"
// import Tables from "layouts/tables"
// import Billing from "layouts/billing"
// import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
// import Profile from "layouts/profile"
import SignIn from "layouts/authentication/sign-in"
import ForgetPassword from "layouts/authentication/fogert-password"
import ResetPassword from "layouts/authentication/reset-password"
// import SignUp from "layouts/authentication/sign-up"

// @mui icons
import Icon from "@mui/material/Icon"
import Packages from "layouts/packages"
import Tracking from "layouts/tracking"
import Returns from "layouts/returns"
import Revenue from "layouts/revenue"
import CalculateRevenue from "layouts/calculate-revenue"
import PackageForm from "layouts/packages/form/packageForm"
import PackageDetails from "layouts/packages/Details"
import ExitVoucher from "layouts/exit-voucher"
import Exchanges from "layouts/exchanges"
import PrintedPackages from "layouts/printed-packages"
import PayedPackage from "layouts/payed-package"
import PreSelectionPackages from "layouts/pre-selection-packages"

const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <Dashboard />,
  // },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "auth",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />,
  },
  {
    type: "auth",
    name: "Forget Password",
    key: "forget-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/forget-password",
    component: <ForgetPassword />,
  },
  {
    type: "auth",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">password</Icon>,
    route: "/reset-password",
    component: <ResetPassword />,
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
  {
    type: "collapse",
    name: "Colis",
    key: "colis",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/colis",
    collapse: [
      {
        route: "/colis",
        component: <Packages />,
      },
      {
        name: "Modifier Colis",
        route: "/colis/modifier-colis/:packageId",
        component: <PackageForm />,
      },
      {
        name: "Détails du Colis",
        route: "/colis/colis-details/:packageId",
        component: <PackageDetails />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Pré-sélection CMD",
    key: "pre-selection-commandes",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/pre-selection-commandes",
    collapse: [
      {
        name: "Liste des commandes (Pré-sélection)",
        route: "/pre-selection-commandes",
        component: <PreSelectionPackages />,
      },
      {
        name: "Modifier Commande (Pré-sélection)",
        route: "/pre-selection-commandes/modifier-commande/:packageId",
        component: <PackageForm />,
      },
      {
        name: "Détails de la Commande (Pré-sélection)",
        route: "/pre-selection-commandes/details-commande/:packageId",
        component: <PackageDetails />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Ajouter un colis",
    key: "nouveau-colis",
    icon: <Icon fontSize="small">create_new_folder</Icon>,
    route: "/nouveau-colis",
    component: <PackageForm />,
  },
  {
    type: "collapse",
    name: "Bon de sortie",
    key: "bon-de-sortie",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/bon-de-sortie",
    component: <ExitVoucher />,
  },
  {
    type: "collapse",
    name: "Colis échangé",
    key: "echange",
    icon: <Icon fontSize="small">assignment_returned</Icon>,
    route: "/echange",
    component: <Exchanges />,
  },
  {
    type: "collapse",
    name: "Colis imprimé",
    key: "colis-imprime",
    icon: <Icon fontSize="small">print</Icon>,
    route: "/colis-imprime",
    component: <PrintedPackages />,
  },
  {
    type: "collapse",
    name: "Suivi de Livraison",
    key: "suivi",
    icon: <Icon fontSize="small">track_changes</Icon>,
    route: "/suivi",
    component: <Tracking />,
  },
  {
    type: "collapse",
    name: "Colis à retourner",
    key: "retours",
    icon: <Icon fontSize="small">assignment_return</Icon>,
    route: "/retours",
    component: <Returns />,
  },
  {
    type: "collapse",
    name: "Revenus",
    key: "revenus",
    icon: <Icon fontSize="small">account_balance</Icon>,
    route: "/revenus",
    component: <Revenue />,
  },
  {
    type: "collapse",
    name: "Comptabilité",
    key: "comptabilite",
    icon: <Icon fontSize="small">calculate</Icon>,
    route: "/comptabilite",
    component: <CalculateRevenue />,
  },
  {
    type: "collapse",
    name: "Colis Payé",
    key: "payed-package",
    icon: <Icon fontSize="small">money</Icon>,
    route: "/payed-package",
    component: <PayedPackage />,
  },
]

export default routes
